module.exports = __webpack_public_path__ + "img/empty-table.5e1ca1a9.svg";